export default "__VITE_ASSET__2a92da35__"